// extracted by mini-css-extract-plugin
var _1 = "SidebarView-module_menu_item__agatVx";
var _2 = "SidebarView-module_menu_item_icon__icY32m";
var _3 = "SidebarView-module_menu_label__PhwXwn";
var _4 = "SidebarView-module_mobile_navbar__kU4v0t";
var _5 = "SidebarView-module_mobile_navbar_container__yiHAJp";
var _6 = "SidebarView-module_opacity__xV9XBl";
var _7 = "SidebarView-module_root_menu_item__Xu4IQg";
var _8 = "SidebarView-module_root_menu_item_active__LoBNod";
var _9 = "SidebarView-module_rotate180__GXNkSb";
var _a = "SidebarView-module_rotate90__j4wEgJ";
var _b = "SidebarView-module_sidebar__Nfi8cI";
var _c = "SidebarView-module_sidebar_body__ejiMOO";
var _d = "SidebarView-module_sidebar_closed__a9u7YR";
var _e = "SidebarView-module_sidebar_container__WzFkRB";
var _f = "SidebarView-module_sidebar_link__NBVVtR";
var _10 = "SidebarView-module_sidebar_link_active__PiLU5_";
var _11 = "SidebarView-module_sidebar_logo_large__PrFpCa";
var _12 = "SidebarView-module_sidebar_logo_small__cK37Fq";
var _13 = "SidebarView-module_sidebar_logo_title__HZEAGc";
var _14 = "SidebarView-module_sidebar_nav__cMi_P5";
var _15 = "SidebarView-module_sidebar_open__ErqsY4";
var _16 = "SidebarView-module_sidebar_toggler__mwNqj0";
var _17 = "SidebarView-module_sidebar_toggler_container__nJXo2S";
var _18 = "SidebarView-module_sidebar_toggler_icon__XYXafn";
var _19 = "SidebarView-module_submenu__x1MQgH";
var _1a = "SidebarView-module_submenu_label__IF3nKp";
var _1b = "SidebarView-module_submenu_nav__WHDnwL";
var _1c = "SidebarView-module_submenu_toggler__czXIaF";
var _1d = "SidebarView-module_transform__zTaNPs";
export { _1 as "menu_item", _2 as "menu_item_icon", _3 as "menu_label", _4 as "mobile_navbar", _5 as "mobile_navbar_container", _6 as "opacity", _7 as "root_menu_item", _8 as "root_menu_item_active", _9 as "rotate180", _a as "rotate90", _b as "sidebar", _c as "sidebar_body", _d as "sidebar_closed", _e as "sidebar_container", _f as "sidebar_link", _10 as "sidebar_link_active", _11 as "sidebar_logo_large", _12 as "sidebar_logo_small", _13 as "sidebar_logo_title", _14 as "sidebar_nav", _15 as "sidebar_open", _16 as "sidebar_toggler", _17 as "sidebar_toggler_container", _18 as "sidebar_toggler_icon", _19 as "submenu", _1a as "submenu_label", _1b as "submenu_nav", _1c as "submenu_toggler", _1d as "transform" }
